export default __webpack_public_path__ + "static/02_lab_kits-3b5da498494747cc28c6fb3dcdb6651a.png";